export default __webpack_public_path__ + "c3d7c8fa40786e553db831e0edc37e0b.svg";